import React, { memo, type ReactElement, useState } from 'react';
import { Box, TableSortable, Typography } from '@saviynt/design-system';

import {
  columns as importColumns,
  sortConfigs,
} from '../data-layer/violationsReportConstants';
import generateRandomData from '../data-layer/violationsReportUtils';

/**
 * ReportTable
 */
function ReportTable(): ReactElement {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const [columns, setColumns] = useState(importColumns);
  const rows = generateRandomData(Math.floor(Math.random() * 1000));

  return (
    <Box className='ReportTable'>
      <Typography kind='body2' desktop='body2-d' mobile='body2-d'>
        {`${rows.length} items`}
      </Typography>
      <TableSortable
        data={rows}
        columns={columns}
        setColumns={setColumns}
        sortConfigs={sortConfigs}
        isWindowScroll={false}
        tableHeight='calc(100vh - 20rem)'
      />
    </Box>
  );
}

export default memo(ReportTable);
